/* tslint:disable */

import React from "react"

const PausedIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" fill="white" />
      </svg>
    </div>
  )
}

export default PausedIcon
